import api from '../../../api/client';
// components/ReceivablesDashboard.js
import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Payables from "./Payables";
import PayablesAnalytics from "../../../components/PayablesAnalytics";
// import {PayablesAnalytics} from "../../../components/ReceivablesAnalytics";

const PayablesDashboard = ({ dateRange, fetchData }) => {
  const [activeTab, setActiveTab] = useState("list");

  return (
     <div className="mt-4">
      <Tabs
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        className="mb-3"
      >
        <Tab eventKey="list" title="Invoice List">
          <Payables dateRange={dateRange} fetchData={fetchData} />
        </Tab>
        <Tab eventKey="analytics" title="Analytics & Reports">
          <PayablesAnalytics dateRange={dateRange} fetchData={fetchData} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default PayablesDashboard;